import patterns from '../../../universal/spinneybeck/patterns'
import sp402 from '../filzfelt/generate-pattern'

export default (pattern, width, height, old) => {
  const { name } = patterns[pattern]

  return /402/.test(name)
    ? sp402(pattern, width, height, old)
    : dnd(pattern, width, height, old)
}

function dnd (pattern, width, height, old) {
  pattern = patterns[pattern]
  const mod = pattern.module

  const result = {}

  const rem = width % 16

  const x0 = rem ? 0 - (16 - rem / 2) : 0
  const y0 = 0

  let row = 0
  for (let y = y0; y < height; y += 16) {
    let col = 0
    for (let x = x0; x < width; x += 16) {
      const key = `${col},${row}`
      const rowIdx = row % mod.length
      const colIdx = col % mod[rowIdx].length
      let id = pattern.module[rowIdx][colIdx].id
      let name = pattern.module[rowIdx][colIdx].name
      let r = pattern.module[rowIdx][colIdx].r
      if (old && (key in old)) {
        id = old[key].id
        name = old[key].name
        r = old[key].r
      }
      const partial = x < 0 || x > width - 16 || y < 0 || y > height - 16
      result[key] = { id, name, r, x, y, partial }
      col += 1
    }
    row += 1
  }

  return result
}



// WEBPACK FOOTER //
// ./src/client/lib/spinneybeck/generate-pattern.js